module.exports = __webpack_public_path__ + "static/media/PL.f6afdb62.svg";